import { HEADER_TYPE_TRANSLATIONS, type HeaderType } from '@tempo-io/roadmap-dto';
import { useTranslation } from 'react-i18next';
import type { IPropertySelectorByID } from '@/lib/api/types/roadmapping';
import { useGetCustomFieldDetailsQuery } from '@/lib/queries/common/useGetCustomFieldsQuery';
import {
  getDateHeaderPeriod,
  headerToCustomFieldId,
  headerToItemField,
  isHeaderStartDate,
} from './utils';

export function useHeaderLabel(headerSelector: IPropertySelectorByID | null): string {
  const { t } = useTranslation();

  const { data: field } = useGetCustomFieldDetailsQuery({
    id: headerToCustomFieldId(headerSelector),
  });

  if (!headerSelector) {
    return t('roadmapping.layout.formatPanel.noHeaderSelectedLabel');
  }

  switch (headerSelector.type) {
    case `ParentItemSelector`: {
      return t(`roadmapping.layout.headers.parentItemLabel`);
    }
    case 'CustomPropertySelectorByID': {
      const itemField: HeaderType | null = headerToItemField(headerSelector);
      return itemField ? t(HEADER_TYPE_TRANSLATIONS[itemField]) : field?.name || '';
    }
    case 'DateSelector': {
      const labelSuffix = isHeaderStartDate(headerSelector.header)
        ? t('roadmapping.layout.headers.fields.startDate')
        : t('roadmapping.layout.headers.fields.endDate');
      const datePeriod = getDateHeaderPeriod(headerSelector.header);
      const periodLabel = t(`roadmapping.layout.headers.fields.period.${datePeriod}`);
      return `${periodLabel} (${labelSuffix})`;
    }
    case 'createdBy': {
      return t(`roadmapping.layout.headers.fields.createdBy`);
    }
    default:
      return t('roadmapping.layout.formatPanel.noHeaderSelectedLabel');
  }
}
